// export { default } from "./Wrapper";

import Wrapper from "./Wrapper"

export default Wrapper;